export const FETCH_SAMPLE_IN_PROCESS_REQUEST = "FETCH_SAMPLE_IN_PROCESS_REQUEST";
export const FETCH_SAMPLE_IN_PROCESS_SUCCESS = "FETCH_SAMPLE_IN_PROCESS_SUCCESS";
export const FETCH_SAMPLE_IN_PROCESS_FAILURE = "FETCH_SAMPLE_IN_PROCESS_FAILURE";